import { useRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";

// Used by customer details, checkout and the mobile admin navigation.
export function BottomSheet({ title, description, onClose, children, className, side = false, returnFocusSelector, lang }) {
  const opener = useRef(document.activeElement);
  return (
    <DialogPrimitive.Root open onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="sheet-overlay" />
        <DialogPrimitive.Content
          lang={lang}
          className={cn(side ? "navigation-sheet" : "bottom-sheet", className)}
          onCloseAutoFocus={(event) => {
            event.preventDefault();
            const target = opener.current?.isConnected ? opener.current : returnFocusSelector && document.querySelector(returnFocusSelector);
            target?.focus();
          }}
        >
          <DialogPrimitive.Title className="sr-only">{title}</DialogPrimitive.Title>
          <DialogPrimitive.Description className="sr-only">{description || "Lihat informasi dan tutup untuk kembali."}</DialogPrimitive.Description>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
